<!--
* @Author: DY
* @Date: 2020-05-27 14:52:13
* @Description: '原材料消耗'
-->
<template>
    <div class="rawMaterialConsume">
        <div class="filterConditions">
            <div class="time iconfont iconriqi" @click="startTimePicker = true">
                <input type="text" v-model="startTimeValue" readonly>
            </div>
            <div class="stations">
                <template v-for="(item, index) in stationData">
                    <van-button
                        :key="index"
                        type="default"
                        :class="{ active: stationIndex == index }"
                        @click="switchingStation(index, item)"
                    >
                        {{ item.name }}
                    </van-button>
                </template>
            </div>
        </div>
        <van-popup v-model="startTimePicker" position="bottom" :overlay="true">
            <van-datetime-picker
                v-model="startCurrentDate"
                type="date"
                title="选择年月日"
                @confirm="startConfirmData"
                @cancel="startTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
        <section>
            <div class="statisticalData" v-if="unitPriceDat.length > 0">
                <template v-for="(item, index) in unitPriceDat">
                    <div :key="index">
                        <h3>{{ item.unit_price }}</h3>
                        <p>{{ item.child_type_name }}<br>(元/吨)</p>
                    </div>
                </template>
            </div>
            <div class="tableBox">
                <div class="title">
                    <h4 class="van_left">
                        原材料消耗用量
                    </h4>
                    <span class="van_right">
                        单位：(千克/方)
                    </span>
                </div>
                <div class="tableList">
                    <table>
                        <thead>
                            <tr>
                                <th>产品标号</th>
                                <th>水泥</th>
                                <th>钙粉</th>
                                <th>粉煤灰</th>
                                <th>矿粉</th>
                                <th>粗骨料</th>
                                <th>细骨料</th>
                                <th>外加剂</th>
                            </tr>
                        </thead>
                        <tbody v-if="Object.keys(classificationData).length > 0">
                            <template v-for="(item,index) in classificationData">
                                <tr :key="index">
                                    <th>{{ item.code }}</th>
                                    <td>{{ item.cement }}</td>
                                    <td>{{ item.calciumPowder }}</td>
                                    <td>{{ item.flyAsh }}</td>
                                    <td>{{ item.mineralPowder }}</td>
                                    <td>{{ item.bigAggregate }}</td>
                                    <td>{{ item.miniAggregate }}</td>
                                    <td>{{ item.wjj }}</td>
                                </tr>
                            </template>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="8">
                                    暂无数据
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'raw-material-consume',
    components: {},
    props: {},
    data() {
        return {
            // 开始时间
            startTimeValue: '',
            // 时间弹出层
            startTimePicker: false,
            // 开始时间默认日期
            startCurrentDate: new Date(),
            // 场站数据
            stationData: [],
            // 选中场站下标
            stationIndex: 0,
            // 选中场站id
            stationID: '',
            // 原材料单价数据
            unitPriceDat: {},
            // 各标号原材料分类消耗数据
            classificationData: {},
        };
    },
    watch: {
        stationID() {
            // 获取原材料单价
            this.getUnitPrice();
            // 获取各标号原材料分类消耗
            this.getClassificationData();
        },
    },
    computed: {},
    created() {
        // 开始时间
        this.startTimeValue = this.formatDate(this.startCurrentDate);
        // 拉取场站数据
        this.getStation();
    },
    mounted() {},
    methods: {
        // 确认选择时间
        startConfirmData(val) {
            this.startTimeValue = this.formatDate(val);
            this.startTimePicker = false;
            // 获取原材料单价
            this.getUnitPrice();
            // 获取各标号原材料分类消耗
            this.getClassificationData();
        },
        // 时间格式处理
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        // 拉取场站
        async getStation() {
            const station = await this.getStationApi();
            if (station) {
                this.stationData = station;
                this.stationID = station[0].station_id;
            }
        },
        // 切换场站
        switchingStation(index, item) {
            this.stationIndex = index;
            this.stationID = item.station_id;
        },
        // 获取原材料单价
        async getUnitPrice() {
            const UnitPrice = await this.getUnitPriceApi();
            if (UnitPrice) {
                this.unitPriceDat = UnitPrice;
            }
        },

        // 获取场站
        async getStationApi() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationLs = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                return stationLs;
            }
            return [];
        },

        // 获取原材料单价数据
        getUnitPriceApi() {
            const path = `/interfaceApi/procurement/material/price/adjust/get_material_price/${this.stationID}/${this.startTimeValue}`;
            return this.$axios.$get(path, { defEx: true });
        },

        // 获取各标号原材料分类消耗
        async getClassificationData() {
            await this.$axios
                .get('/interfaceApi/report/yclxh/get_consume_label?'
                    + `beginTime=${this.startTimeValue} 00:00:00&`
                    + `endTime=${this.startTimeValue} 23:59:59&`
                    + `station_id=${this.stationID}`
                )
                .then(res => {
                    if (res && res.length > 0) {
                        const newData = {};
                        res.forEach(e => {
                            if (Object.keys(newData).indexOf('' + e.strength_grade_name) === -1) {
                                newData[e.strength_grade_name] = {};
                                newData[e.strength_grade_name].code = e.strength_grade_name;
                            }

                            if (e.material_category_code === '202') {
                                // 水泥
                                newData[e.strength_grade_name].cement = e.actual_value;
                            } else if (e.material_category_code === '205-SHF') {
                                // 钙粉
                                newData[e.strength_grade_name].calciumPowder = e.actual_value;
                            } else if (e.material_category_code === '205-FMH') {
                                // 粉煤灰
                                newData[e.strength_grade_name].flyAsh = e.actual_value;
                            } else if (e.material_category_code === '205-KZF') {
                                // 钙粉
                                newData[e.strength_grade_name].mineralPowder = e.actual_value;
                            } else if (e.material_category_code === '204') {
                                // 粗骨料
                                newData[e.strength_grade_name].bigAggregate = e.actual_value;
                            } else if (e.material_category_code === '203') {
                                // 细骨料
                                newData[e.strength_grade_name].miniAggregate = e.actual_value;
                            } else if (e.material_category_code === '208') {
                                // 外加剂
                                newData[e.strength_grade_name].wjj = e.actual_value;
                            }
                        });
                        this.classificationData = newData;
                    } else {
                        this.classificationData = {};
                    }
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
    },
};
</script>

<style scoped lang="stylus">
.rawMaterialConsume
    height 100%
    .filterConditions
        display flex
        align-items center
        height 80rpx
        padding 15rpx 10rpx
        border-bottom 2px solid #F0F0F0
        .stations
            display flex
            align-items center
            width calc(100% - 140rpx)
            height 100%
            overflow-x auto
            overflow-y hidden
        .time
            width 130rpx
            height 30rpx
            line-height 28rpx
            margin 0 5rpx
            position relative
            input
                width 130rpx
                height 30rpx
                border 1px solid #D7D7D7
                border-radius 4rpx
                text-indent 30rpx
            &:before
                line-height 30rpx
                font-size 16rpx
                color #979EA7
                position absolute
                left 5rpx
        .van-button
            flex-shrink 0
            width 60rpx
            height 30rpx
            line-height 14rpx
            margin 0 5rpx
            padding 0
            font-size 12rpx
            color #666666
            border 1px solid #D7D7D7
            border-radius 4rpx
            box-shadow 2rpx 4rpx 8rpx rgba(84, 148, 243, 0.2)
            &.active
                background #3495FB
                border-color #0E84FF
                color #fff
                box-shadow 2rpx 4rpx 8rpx rgba(84, 148, 243, 1)
    section
        .statisticalData
            /*height 73rpx*/
            display flex
            padding-top 10rpx
            flex-wrap wrap
            >div
                width 25%
                text-align center
                padding-bottom 10rpx
                &:nth-of-type(1)
                    h3
                        color #5588F1
                &:nth-of-type(2)
                    h3
                        color #FA8436
                &:nth-of-type(3)
                    h3
                        color #21BDCC
                &:nth-of-type(4)
                    h3
                        color #FFB729
            h3
                font-size 16rpx
                line-height 24rpx
            p
                font-size 12rpx
                line-height 13rpx
                color #979EA7
        .tableBox
            border-top 15rpx solid #F0F0F0
            padding 15rpx
            .title
                height 16rpx
                overflow hidden
                margin-bottom 10rpx
                h4
                    font-size 16rpx
                    line-height 16rpx
                    color #333333
                span
                    font-size 12rpx
                    height 16rpx
                    line-height 16rpx
                    color #979EA7
            .tableList
                table
                    width 100%
                    font-size 13rpx
                    th,td
                        font-weight 400
                        text-align center
                        height 40rpx
                        width 70rpx
                    th
                        background #EBF0FC
                        border 1px solid #DEE3EF
                        color #333333
                    td
                        background rgba(85, 136, 241, 0.04)
                        color #5588F1
</style>
